import type { CancelToken } from 'axios';
import {
  apiGet, apiPost, retryApiRequest,
} from '~/_shared/utils/api/api.helpers';

export type AgsReportRingDataRequest = {
  varlistId: string;
  country: 'usa' | 'can';
  radiiInMiles: number[];
  lat: number;
  lng: number;
  returnType?: 'json' | 'pdf';
};

export type AgsReportRingDataResponse = {
  latitude: number;
  longitude: number;
  areas: ReadonlyArray<ReportAreaResponse>;
  timeInSeconds: number;
  message: string;
};

export type AgsReportPolygonDataRequest = {
  varlistId: string;
  polygon: string;
  label?: string;
  returnType?: 'json' | 'pdf';
  country: 'usa' | 'can';
};

export type AgsReportPolygonResponse = {
  latitude: number;
  longitude: number;
  areas: ReadonlyArray<ReportAreaResponse>;
  timeInSeconds: number;
  message: string;
};

type ReportDataItem = {
  tag: string;
  description: string;
  value: string;
};

export type ReportAreaResponse = ReportArea | ReportAreaEmpty;

type ReportArea = {
  type: string;
  extent: number;
  label: string;
  data: ReportDataItem[];
};

type ReportAreaEmpty = {
  type: null;
  extent: number;
  label: null;
  data: null;
};

export function getAgsReportRingData(request: AgsReportRingDataRequest & { returnType: 'pdf' }, cancelToken?: CancelToken): Promise<Blob>;
export function getAgsReportRingData(request: AgsReportRingDataRequest, cancelToken?: CancelToken): Promise<{ report: AgsReportRingDataResponse }>;
export function getAgsReportRingData({
  varlistId,
  country,
  lat,
  lng,
  radiiInMiles,
  returnType = 'json',
}: AgsReportRingDataRequest, cancelToken?: CancelToken): Promise<Blob | { report: AgsReportRingDataResponse }> {
  return retryApiRequest(() => apiGet('/api/ags/export-report-ring', {
    radii: radiiInMiles.join(','),
    varlist: varlistId,
    country,
    latitude: lat,
    longitude: lng,
    returnType,
    empty: true,
  }, {
    cancelToken,
    responseType: returnType === 'pdf' ? 'blob' : 'json',
  }));
}

export const getAgsPolygonReportData = ({
  varlistId,
  country,
  polygon,
  label,
  returnType = 'json',
}: AgsReportPolygonDataRequest, cancelToken?: CancelToken): Promise<{ report: AgsReportPolygonResponse }> => {
  const requestUrl = '/api/ags/export-report-polygon';

  return retryApiRequest(() => apiPost(requestUrl, {
    pgn: polygon,
    varlist: varlistId,
    country,
    label,
    returnType,
    empty: true,
  }, {
    cancelToken,
  }));
};
